export default __webpack_public_path__ + "static/media/pricing2.a48392f0.jpg";